export default __webpack_public_path__ + "static/media/LogoUSPE.b91367a5.webp";